const formatExpression = (expression: string): string => {
  if (expression.length < 100 || /[\r\n]|\/\/|'''|"""|\b(?:[bB]?[rR]|[bB])["']/.test(expression)) return expression;

  const tokens = expression.match(/"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|&&|\|\||[()+]|[^"'&|()+]+|./g) ?? [];
  let depth = 0;
  let formatted = '';
  for (const token of tokens) {
    if (token === '(') depth += 1;
    if (token === ')') depth = Math.max(0, depth - 1);
    const exponentSign = token === '+' && /\d[eE]$/.test(formatted);
    if ((token === '&&' || token === '||' || token === '+') && !exponentSign) {
      formatted = `${formatted.trimEnd()}\n${'  '.repeat(depth)}${token}`;
    } else {
      formatted += token;
    }
  }
  return formatted;
};

export { formatExpression };
